export function consumerUnit(unit) {
    return {
        ...(unit.kind ? { kind: unit.kind } : {}),
        id: unit.id,
        availableAtUtc: unit.availableAtUtc,
        display: unit.display,
        presentation: unit.presentation,
        interaction: unit.interaction,
    };
}
